export function parseFile(b64data, type) {
    const byteCharacters = atob(b64data);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: type });
    const file = new File([blob], 'casa.pdf', { type: type });
    const url = URL.createObjectURL(file)
    return url
}